import { LiteralExpression } from './LiteralExpression.js';
export class NilExpression extends LiteralExpression {
    constructor() {
        super(undefined);
    }
    parseValue() {
        return;
    }
}
//# sourceMappingURL=NilExpression.js.map